import { render, staticRenderFns } from "./RBalloon.vue?vue&type=template&id=053d81e0&scoped=true"
import script from "./RBalloon.vue?vue&type=script&lang=js"
export * from "./RBalloon.vue?vue&type=script&lang=js"
import style0 from "./RBalloon.vue?vue&type=style&index=0&id=053d81e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d81e0",
  null
  
)

export default component.exports